import styled from 'styled-components';
import Icon from 'lqa-ui/lib/Components/Icon';

export const GreyDot = styled.div`
    width: ${({ theme }) => theme.spacing.m};
    height: ${({ theme }) => theme.spacing.m};
    border: 2px solid ${({ theme }) => theme.colors.battleShipGray};
    border-radius: 50%;
    `;

export const IconWrapper = styled.div`
    padding-top: ${({ theme }) => theme.spacing.xs};
    `;

export const IconCircle = styled(Icon) <{ isFilled?: boolean }>`
    background-color: ${({ isFilled, theme }) => (isFilled ? theme.colors.verdigris : 'transparent')};
    color: ${({ isFilled, theme }) => (isFilled ? 'white' : theme.colors.verdigris)};
    fill: ${({ isFilled }) => (isFilled ? 'white' : 'transparent')};
    border-radius: 15px;
    width: ${({ isFilled }) => (isFilled ? '20px' : '16px')};
    height: ${({ isFilled }) => (isFilled ? '20px' : '16px')};
    border: ${({ isFilled, theme }) => (isFilled ? 'none' : `2px solid ${theme.colors.verdigris}`)};
  `;
